import { render, staticRenderFns } from "./FootprintTableSorting.vue?vue&type=template&id=49f4b046&scoped=true&"
import script from "./FootprintTableSorting.vue?vue&type=script&lang=js&"
export * from "./FootprintTableSorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f4b046",
  null
  
)

export default component.exports